"use strict";

angular
    .module("harriApp")
    .service("positionsDataService", PositionsDataService);

PositionsDataService.$inject = ['$q'];

function PositionsDataService($q) {
    var self = this;

    self.getSystemPositions = function () {
        const defer = $q.defer();

        PositionsAPI.getSystemPositions()
            .then(function (systemPositions) {
                defer.resolve(systemPositions);
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getSystemPositionsFlat = function () {
        const defer = $q.defer();

        self.getSystemPositions()
            .then((systemPositions) => {
                defer.resolve(buildFlatPositions(systemPositions));
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.isActivePosition = function (positionCode, brandId) {
        var defer = $q.defer();
        var isActive = false;
        var promise = self.getActivePositions();
        if (brandId) {
            promise = self.getActivePositions(false, brandId)
        }

        promise
            .then(function (positions) {
                for (var i in positions) {
                    for (var j in positions[i].PositionType.Position) {
                        if (positions[i].PositionType.Position[j].code === positionCode && positions[i].PositionType.Position[j].status === 'ACTIVE') {
                            isActive = true;
                            break;
                        }
                    }
                }
                defer.resolve(isActive);
            }).catch(function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };


    var buildFlatPositions = function (positions) {
        var data = [];
        for (var i in positions) {
            for (var j in positions[i].PositionType.Position) {
                data.push({
                    id: positions[i].PositionType.Position[j].id,
                    code: positions[i].PositionType.Position[j].code,
                    name: positions[i].PositionType.Position[j].name,
                    status: positions[i].PositionType.Position[j].status,
                    groupName: positions[i].PositionType.name,
                    groupCode: positions[i].PositionType.code,
                    category: {
                        id: positions[i].PositionType.id,
                        code: positions[i].PositionType.code,
                        name: positions[i].PositionType.name
                    }
                })
            }
        }

        return (_.sortBy(data, 'name'));
    };

    self.getActivePositions = function (includeArchived, brandId, noCache) {
        const defer = $q.defer();

        PositionsAPI.loadPositions(includeArchived, brandId, noCache)
            .then((positions) => {
                defer.resolve(positions);
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getActivePositionsFlat = function (includeArchived, brandId, noCache) {
        var defer = $q.defer();

        self.getActivePositions(includeArchived, brandId, noCache)
            .then((positions) => {
                defer.resolve(buildFlatPositions(positions));
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getActiveCategories = function (includeArchived, brandId, noCache) {
        var defer = $q.defer();
        self.getActivePositions(includeArchived, brandId, noCache)
            .then(function (categories) {
                var categoryList = [];
                for (var i in categories) {
                    categoryList.push(categories[i].PositionType);
                }
                defer.resolve(categoryList);
            }).catch(function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };

    self.clearCachedPositions = function () {
        HReportingAPI.invalidateCacheEntries(['brands']);
        TeamLiveReportsAPI.invalidateCacheEntries(['brands']);
        PositionsAPI.invalidateCacheEntries(['category_positions']);
        TeamScheduleAPI.invalidateCacheEntries(['category_positions']);
    };

    self.getPositionsMapped = function (includeArchived) {
        var defer = $q.defer();

        self.getActivePositions(includeArchived)
            .then(function (categories) {
                var responseObject = {
                    categories: {},
                    positions: {},
                };

                for (var i in categories) {
                    var category = categories[i];
                    var mappedCategory = {
                        positions: category.PositionType.Position,
                        code: category.PositionType.code,
                        name: category.PositionType.name,
                        id: category.PositionType.id,
                    };
                    responseObject.categories[mappedCategory.code] = {
                        name: mappedCategory.name,
                        code: mappedCategory.code,
                        id: mappedCategory.id,
                        positions: mappedCategory.positions,
                    };
                    for (var j in mappedCategory.positions) {
                        var position = mappedCategory.positions[j];
                        responseObject.positions[position.code] = {
                            name: position.name,
                            id: position.id,
                            category_code: mappedCategory.code,
                        };
                    }
                }

                defer.resolve(responseObject);
            })
            .catch(function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

}